(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relieftouch"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('uvx-rt');
  if(!root)return;
  var dataEl=document.getElementById('uvx-rt-data');
  var D={};try{D=JSON.parse(dataEl.textContent);}catch(e){}

  // gallery thumbs
  var slides=document.getElementById('rt-slides');
  var thumbs=root.querySelectorAll('.rt-thumb');
  thumbs.forEach(function(t){
    t.addEventListener('click',function(){
      var i=+t.getAttribute('data-i');
      var slide=slides.children[i];
      if(slide)slides.scrollTo({left:slide.offsetLeft*(document.dir==='rtl'?-1:1)+ (document.dir==='rtl'? slides.scrollWidth - slides.clientWidth : 0),behavior:'smooth'});
      if(slide)slide.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'});
      thumbs.forEach(function(x){x.classList.remove('is-active');});
      t.classList.add('is-active');
    });
  });
  slides.addEventListener('scroll',function(){
    var c=slides.scrollLeft+slides.clientWidth/2;var best=0,bd=1e9;
    for(var i=0;i<slides.children.length;i++){var s=slides.children[i];var ctr=s.offsetLeft+s.clientWidth/2;var d=Math.abs(ctr-c);if(d<bd){bd=d;best=i;}}
    thumbs.forEach(function(x){x.classList.toggle('is-active',+x.getAttribute('data-i')===best);});
  },{passive:true});

  // add to cart -> native drawer (mirror product-form)
  function addToCart(e){
    if(e)e.preventDefault();
    if(!D.vid)return;
    var btn=document.getElementById('rt-atc');
    var orig=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='מוסיף...';}
    var fd=new FormData();fd.append('id',D.vid);fd.append('quantity',1);
    var cart=document.querySelector('cart-notification')||document.querySelector('cart-drawer');
    if(cart&&cart.getSectionsToRender){
      var ids=cart.getSectionsToRender().map(function(s){return s.id;}).join(',');
      fd.append('sections',ids);fd.append('sections_url',window.location.pathname);
    }
    fetch('/cart/add',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/javascript'},body:fd})
      .then(function(r){return r.json();})
      .then(function(res){
        if(cart&&cart.renderContents){cart.renderContents(res);}
        else{window.location.href='/cart';}
        if(btn){btn.disabled=false;btn.textContent=orig;}
      })
      .catch(function(){window.location.href='/cart';});
  }
  var form=document.getElementById('rt-form');
  if(form)form.addEventListener('submit',addToCart);
  var atc2=document.getElementById('rt-atc2');
  if(atc2)atc2.addEventListener('click',function(e){e.preventDefault();addToCart(e);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uverix-ankle-advertorial-neuro"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('uva-neuro');
  if(!root) return;
  var bar=root.querySelector('#uvan-float');
  if(!bar) return;
  // Ensure the fixed bar never permanently masks the final CTA: pad the article
  // by the bar height on mobile where it becomes a full-width bottom bar.
  var pad=function(){
    var isMobile=window.matchMedia('(max-width:600px)').matches;
    root.style.paddingBottom=isMobile?(bar.offsetHeight+16)+'px':'96px';
  };
  window.addEventListener('resize',pad,{passive:true});
  pad();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uverix-ankle-advertorial-test"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('uva-test');
  if(!root) return;
  var bar=root.querySelector('#uvat-float');
  if(!bar) return;
  // Ensure the fixed bar never permanently masks the final CTA: pad the article
  // by the bar height on mobile where it becomes a full-width bottom bar.
  var pad=function(){
    var isMobile=window.matchMedia('(max-width:600px)').matches;
    root.style.paddingBottom=isMobile?(bar.offsetHeight+16)+'px':'96px';
  };
  window.addEventListener('resize',pad,{passive:true});
  pad();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uverix-ankle"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('uverix-ankle');
  if(!root) return;
  var dataEl = document.getElementById('uva-variant-data');
  var VD = {};
  try { VD = JSON.parse(dataEl.textContent); } catch(e){}
  var state = { color: 'אפור', size: 'M', tier: '2' };
  function bundleVid(arr, color, size){
    arr = arr || [];
    for(var i=0;i<arr.length;i++){ if(arr[i].c===color && arr[i].s===size) return arr[i].id; }
    return null;
  }
  // gallery — scroll-snap carousel
  var car = root.querySelector('[data-uva-carousel]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.uva-thumb'));
  function goTo(i){
    if(!car) return;
    var n = car.children.length;
    i = Math.max(0, Math.min(n-1, i));
    var slide = car.children[i];
    if(slide) car.scrollTo({left: slide.offsetLeft, behavior:'smooth'});
  }
  function currentIndex(){
    if(!car || !car.children.length) return 0;
    var w = car.clientWidth || 1;
    return Math.round(Math.abs(car.scrollLeft) / w);
  }
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){ goTo(parseInt(t.getAttribute('data-i')||'0',10)); });
  });
  if(car){
    var scrollT;
    car.addEventListener('scroll', function(){
      clearTimeout(scrollT);
      scrollT = setTimeout(function(){
        var i = currentIndex();
        thumbs.forEach(function(t,k){ t.classList.toggle('active', k===i); });
      }, 80);
    }, {passive:true});
  }
  var prevBtn = root.querySelector('[data-uva-prev]');
  var nextBtn = root.querySelector('[data-uva-next]');
  if(prevBtn) prevBtn.addEventListener('click', function(){ goTo(currentIndex()-1); });
  if(nextBtn) nextBtn.addEventListener('click', function(){ goTo(currentIndex()+1); });
  // color swatches
  root.querySelectorAll('.uva-swatch').forEach(function(el){
    el.addEventListener('click', function(){
      root.querySelectorAll('.uva-swatch').forEach(function(x){x.classList.remove('active')});
      el.classList.add('active');
      state.color = el.getAttribute('data-color');
      var lbl = root.querySelector('[data-uva-colorlabel]'); if(lbl) lbl.textContent = '· ' + state.color;
      resolveVariant();
    });
  });
  // size
  var sizeEl = root.querySelector('[data-uva-size]');
  if(sizeEl){
    sizeEl.addEventListener('change', function(){ state.size = sizeEl.value; resolveVariant(); });
  }
  // tiers
  function paintTiers(){
    root.querySelectorAll('.uva-tier').forEach(function(x){
      var on = x.classList.contains('active');
      x.style.setProperty('background', on ? 'var(--uva-mint)' : '#fff', 'important');
      x.style.setProperty('border-color', on ? 'var(--uva-brand)' : 'var(--uva-line)', 'important');
      x.style.setProperty('box-shadow', on ? '0 6px 18px rgba(26,107,95,.18)' : 'none', 'important');
    });
  }
  root.querySelectorAll('.uva-tier').forEach(function(el){
    el.addEventListener('click', function(){
      var t = el.getAttribute('data-tier');
      state.tier = t;
      if(typeof showExtraPairs==='function') showExtraPairs(parseInt(t,10)||1);
      root.querySelectorAll('.uva-tier').forEach(function(x){x.classList.remove('active')});
      el.classList.add('active');
      var input = root.querySelector('input[name="uva-tier"][value="'+t+'"]');
      if(input) input.checked = true;
      paintTiers();
      resolveVariant();
    });
  });
  paintTiers();
  function resolveVariant(){
    var vidInput = root.querySelector('[data-uva-vid]');
    var cta = root.querySelector('[data-uva-cta]');
    var vid = null;
    if(state.tier === '1'){
      var key = state.color + ' / ' + state.size;
      vid = VD.single_variants && VD.single_variants[key];
      var skuEl = root.querySelector('[data-uva-sku]');
      if(skuEl){ skuEl.textContent = 'UVX-ANK-' + (state.color==='שחור'?'BLK':'GRY') + '-' + state.size; }
    } else {
      var skuElB = root.querySelector('[data-uva-sku]');
      if(skuElB){ skuElB.textContent = 'UVX-ANK-' + (state.color==='שחור'?'BLK':'GRY') + '-' + state.size; }
    }
    // bundle tiers (2/4): variant resolved per-sleeve at submit; leave vid null here
    if(vidInput) vidInput.value = vid || '';
    if(cta && VD.prices && VD.prices[state.tier]) cta.textContent = 'הוסף לעגלה — ₪' + VD.prices[state.tier];
  }
  // scroll to top
  root.querySelectorAll('[data-uva-scroll-top]').forEach(function(a){
    a.addEventListener('click', function(e){
      e.preventDefault();
      root.scrollIntoView({behavior:'smooth', block:'start'});
    });
  });
  root.querySelectorAll('[data-uva-sizescroll]').forEach(function(a){
    a.addEventListener('click', function(e){
      e.preventDefault();
      var t=document.getElementById('uva-sizeguide');
      if(t) t.scrollIntoView({behavior:'smooth', block:'start'});
    });
  });
  // video autoplay if any
  var io2 = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      var v = en.target;
      if(en.isIntersecting){ try{ v.play(); }catch(e){} } else { try{ v.pause(); }catch(e){} }
    });
  }, {threshold: 0.35});
  root.querySelectorAll('video').forEach(function(v){ io2.observe(v); });
  // compare slider
  var cmp = root.querySelector('[data-uva-compare]');
  if(cmp){
    var cmpTop = cmp.querySelector('.uva-compare-top');
    var cmpLine = cmp.querySelector('.uva-compare-line');
    var cmpRange = cmp.querySelector('.uva-compare-range');
    var setCmp = function(v){
      if(cmpTop) cmpTop.style.width = v + '%';
      if(cmpLine) cmpLine.style.left = v + '%';
    };
    if(cmpRange){ cmpRange.addEventListener('input', function(){ setCmp(this.value); }); }
    setCmp(50);
  }
  // cart form
  var form = root.querySelector('[data-uva-form]');
  if(form){
    var extraPairs = [].slice.call(root.querySelectorAll('.uva-xpair'));
    var mixWrap = root.querySelector('[data-uva-mixwrap]');
    var mixPanel = root.querySelector('[data-uva-xpairs]');
    var mixToggle = root.querySelector('[data-uva-mixtoggle]');
    var allNote = root.querySelector('[data-uva-allnote]');
    function mixOpen(){ return mixPanel && !mixPanel.hidden; }
    function prefillPairs(){
      extraPairs.forEach(function(p){
        p.querySelectorAll('.uva-xsw').forEach(function(x){ x.classList.toggle('active', x.getAttribute('data-color')===state.color); });
        var s=p.querySelector('.uva-xsize'); if(s) s.value = state.size;
      });
    }
    function showExtraPairs(n){
      var bundle = n>1;
      if(mixWrap) mixWrap.hidden = true; /* mix disabled — packs use full-price pack variant (knee model), closes 124.50 unit exploit */
      if(allNote) allNote.hidden = !bundle;
      if(!bundle && mixPanel){ mixPanel.hidden = true; if(mixToggle) mixToggle.classList.remove('is-open'); }
      extraPairs.forEach(function(p){ var idx=parseInt(p.getAttribute('data-xpair'),10)||1; p.hidden = (idx>n); });
    }
    if(mixToggle){
      mixToggle.addEventListener('click', function(){
        if(!mixPanel) return;
        var willOpen = mixPanel.hidden;
        if(willOpen){ prefillPairs(); }
        mixPanel.hidden = !willOpen;
        mixToggle.classList.toggle('is-open', willOpen);
      });
    }
    extraPairs.forEach(function(p){
      p.querySelectorAll('.uva-xsw').forEach(function(sw){
        sw.addEventListener('click', function(){
          p.querySelectorAll('.uva-xsw').forEach(function(x){ x.classList.remove('active'); });
          sw.classList.add('active');
        });
      });
    });
    showExtraPairs(parseInt(state.tier,10)||1);

    form.addEventListener('submit', function(e){
      e.preventDefault();
      resolveVariant();
      var _tier = parseInt(state.tier,10)||1;
      var fd = new FormData();
      if(_tier === 1){
        // single sleeve — real variant on the single product (SKU already correct)
        var vidInput = form.querySelector('[data-uva-vid]');
        if(!vidInput || !vidInput.value){
          alert('שגיאה בהגדרת המוצר. פנו לתמיכה.');
          return;
        }
        fd.append('items[0][id]', vidInput.value);
        fd.append('items[0][quantity]', 1);
      } else {
        // bundle — each SLEEVE becomes its OWN line with its OWN real per-unit SKU
        // (pack-2 unit ₪99.50, pack-4 unit ₪74.75) so a MIXED pack ships each sleeve's
        // colour+size correctly and the pack total stays ₪199 / ₪299.
        var arr = _tier===4 ? VD.bundle4 : VD.bundle2;
        var order = [], q = {};
        function pushUnit(col, sz){
          var vid = bundleVid(arr, col, sz);
          if(vid){ if(q[vid]==null){ q[vid]=0; order.push(vid); } q[vid]++; }
        }
        if(mixOpen()){
          extraPairs.forEach(function(p){
            var idx = parseInt(p.getAttribute('data-xpair'),10)||1;
            if(idx <= _tier){
              var _xa=p.querySelector('.uva-xsw.active');
              var _xs=p.querySelector('.uva-xsize');
              pushUnit(_xa?_xa.getAttribute('data-color'):state.color, _xs?_xs.value:state.size);
            }
          });
        } else {
          // NON-mixed pack: ONE line = full-price pack variant (₪249 / ₪399), qty 1, pack SKU (UVX-ANK-PACK2/4-…)
          var packArr = _tier===4 ? VD.packFull4 : VD.packFull2;
          var packVid = bundleVid(packArr, state.color, state.size);
          if(packVid){ q[packVid]=1; order.push(packVid); }
        }
        if(!order.length){ alert('שגיאה בהגדרת המוצר. פנו לתמיכה.'); return; }
        var _ix=0;
        for(var _o=0;_o<order.length;_o++){ fd.append('items['+_ix+'][id]', order[_o]); fd.append('items['+_ix+'][quantity]', q[order[_o]]); _ix++; }
      }
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if(cart && typeof cart.getSectionsToRender === 'function'){
        fd.append('sections', cart.getSectionsToRender().map(function(s){return s.id}).join(','));
        fd.append('sections_url', window.location.pathname);
      }
      var cta = form.querySelector('[data-uva-cta]');
      var origTxt = cta ? cta.textContent : '';
      if(cta){ cta.setAttribute('disabled','disabled'); cta.textContent = 'מוסיף…'; }
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add', {
        method: 'POST',
        headers: {'X-Requested-With':'XMLHttpRequest','Accept':'application/javascript'},
        body: fd
      }).then(function(r){ return r.json(); }).then(function(res){
        if(cart && typeof cart.renderContents === 'function'){
          cart.renderContents(res);
          if(cart.classList.contains('is-empty') && cart.querySelector('.cart-item')){ cart.classList.remove('is-empty'); }
        } else {
          window.location.href = (window.Shopify.routes.root || '/') + 'cart';
        }
      }).catch(function(){
        window.location.href = (window.Shopify.routes.root || '/') + 'cart';
      }).finally(function(){
        if(cta){ cta.removeAttribute('disabled'); cta.textContent = origTxt; }
      });
    });
  }
  resolveVariant();

  /* ---- floating buy box ---- */
  var fbForm = form;
  var bar  = root.querySelector('[data-uva-floatbar]');
  var PRICES = {'1':169,'2':249,'4':399};
  var WAS    = {'1':259,'2':518,'4':1036};
  function curState(){
    var sw = root.querySelector('.uva-swatch.active');
    var szEl = root.querySelector('[data-uva-size]');
    var tierEl = root.querySelector('.uva-tier.active');
    return {
      color: sw ? sw.getAttribute('data-color') : 'אפור',
      size: szEl ? szEl.value : 'M',
      tier: tierEl ? tierEl.getAttribute('data-tier') : '1'
    };
  }
  function setText(sel, txt){ var el = root.querySelector(sel); if(el) el.textContent = txt; }
  function sync(){
    var s = curState();
    // headline (under the gallery) always shows the single "from" price
    var off1 = Math.round((WAS['1'] - PRICES['1']) / WAS['1'] * 100);
    setText('[data-uva-pricenow]', '₪' + PRICES['1']);
    setText('[data-uva-pricewas]', '₪' + WAS['1']);
    var offEl = root.querySelector('.uva-price-off'); if(offEl) offEl.textContent = 'חיסכון ' + off1 + '%';
    // floating bar reflects the selected pack (its button adds that pack)
    setText('[data-uva-floatprice]', '₪' + (PRICES[s.tier] || PRICES['1']));
    var fs = root.querySelector('.uva-float-price s'); if(fs) fs.textContent = '₪' + (WAS[s.tier] || WAS['1']);
  }
  root.addEventListener('click', function(e){
    if(e.target.closest('.uva-swatch') || e.target.closest('.uva-tier')) setTimeout(sync, 0);
  });
  if(sizeEl) sizeEl.addEventListener('change', function(){ setTimeout(sync, 0); });
  sync();
  if(bar && 'IntersectionObserver' in window && fbForm){
    var io3 = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting) bar.classList.remove('show');
        else if(en.boundingClientRect.top < 0) bar.classList.add('show');
        else bar.classList.remove('show');
      });
    }, {threshold: 0});
    io3.observe(fbForm);
  }
  var fcta = root.querySelector('[data-uva-floatcta]');
  if(fcta && fbForm){
    fcta.addEventListener('click', function(){
      var realCta = fbForm.querySelector('[data-uva-cta]');
      if(typeof fbForm.requestSubmit === 'function'){ fbForm.requestSubmit(realCta || undefined); }
      else if(realCta){ realCta.click(); }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uverix-gloves"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('uverix-gloves');
  if(!root) return;
  var dataEl = document.getElementById('uvg-variant-data');
  var VD = {};
  try { VD = JSON.parse(dataEl.textContent); } catch(e){}
  var state = { material: 'במבוק אפור', size: 'M', tier: '1' };
  function bundleVid(arr, material, size){
    arr = arr || [];
    for(var i=0;i<arr.length;i++){ if(arr[i].m===material && arr[i].s===size) return arr[i].id; }
    return null;
  }
  // gallery — scroll-snap carousel
  var car = root.querySelector('[data-uvg-carousel]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.uvg-thumb'));
  function goTo(i){
    if(!car) return;
    var n = car.children.length;
    i = Math.max(0, Math.min(n-1, i));
    var slide = car.children[i];
    if(slide) car.scrollTo({left: slide.offsetLeft, behavior:'smooth'});
  }
  function currentIndex(){
    if(!car || !car.children.length) return 0;
    var w = car.clientWidth || 1;
    // works for both LTR and RTL scroll coordinate systems
    return Math.round(Math.abs(car.scrollLeft) / w);
  }
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){ goTo(parseInt(t.getAttribute('data-i')||'0',10)); });
  });
  if(car){
    var scrollT;
    car.addEventListener('scroll', function(){
      clearTimeout(scrollT);
      scrollT = setTimeout(function(){
        var i = currentIndex();
        thumbs.forEach(function(t,k){ t.classList.toggle('active', k===i); });
      }, 80);
    }, {passive:true});
  }
  var prevBtn = root.querySelector('[data-uvg-prev]');
  var nextBtn = root.querySelector('[data-uvg-next]');
  // in RTL, "next" moves to the following slide index regardless of visual direction
  if(prevBtn) prevBtn.addEventListener('click', function(){ goTo(currentIndex()-1); });
  if(nextBtn) nextBtn.addEventListener('click', function(){ goTo(currentIndex()+1); });
  // material swatches
  root.querySelectorAll('.uvg-swatch').forEach(function(el){
    el.addEventListener('click', function(){
      root.querySelectorAll('.uvg-swatch').forEach(function(x){x.classList.remove('active')});
      el.classList.add('active');
      state.material = el.getAttribute('data-material');
      var gmap={"במבוק אפור":"https://cdn.shopify.com/s/files/1/0678/2307/5478/files/uverix-gloves-hero-tag.png?v=1783006953","פרפורמנס שחור":"https://cdn.shopify.com/s/files/1/0678/2307/5478/files/uverix-gloves-performance-tag.png?v=1783006850"};

      if(gmap[state.material])root.querySelectorAll('.uvg-ttimg').forEach(function(t){t.src=gmap[state.material];});
      resolveVariant();
    });
  });
  // size
  var sizeEl = root.querySelector('[data-uvg-size]');
  if(sizeEl){
    sizeEl.addEventListener('change', function(){ state.size = sizeEl.value; resolveVariant(); });
  }
  // tiers
  root.querySelectorAll('.uvg-tier').forEach(function(el){
    el.addEventListener('click', function(){
      var t = el.getAttribute('data-tier');
      state.tier = t;
      if(typeof showExtraPairs==='function') showExtraPairs(parseInt(t,10)||1);
      root.querySelectorAll('.uvg-tier').forEach(function(x){x.classList.remove('active')});
      el.classList.add('active');
      var input = root.querySelector('input[name="uvg-tier"][value="'+t+'"]');
      if(input) input.checked = true;
      resolveVariant();
    });
  });
  function resolveVariant(){
    var vidInput = root.querySelector('[data-uvg-vid]');
    var cta = root.querySelector('[data-uvg-cta]');
    var vid = null;
    if(state.tier === '1'){
      // Real variant on single product — lookup by material+size
      var key = state.material + ' / ' + state.size;
      vid = VD.single_variants && VD.single_variants[key];
    }
    // bundle tiers (2/4): variant is resolved per-pair at submit time, leave vid null here
    if(vidInput) vidInput.value = vid || '';
    if(cta && VD.prices && VD.prices[state.tier]) cta.textContent = 'הוסף לעגלה — ₪' + VD.prices[state.tier];
  }
  resolveVariant();
  // scroll to top
  root.querySelectorAll('[data-uvg-scroll-top]').forEach(function(a){
    a.addEventListener('click', function(e){
      e.preventDefault();
      root.scrollIntoView({behavior:'smooth', block:'start'});
    });
  });
  // video autoplay if any
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      var v = en.target;
      if(en.isIntersecting){ try{ v.play(); }catch(e){} } else { try{ v.pause(); }catch(e){} }
    });
  }, {threshold: 0.35});
  root.querySelectorAll('video').forEach(function(v){ io.observe(v); });
  // bamboo vs performance comparison slider
  var cmp = root.querySelector('[data-uvg-compare]');
  if(cmp){
    var cmpTop = cmp.querySelector('.uvg-compare-top');
    var cmpLine = cmp.querySelector('.uvg-compare-line');
    var cmpRange = cmp.querySelector('.uvg-compare-range');
    var setCmp = function(v){
      if(cmpTop) cmpTop.style.width = v + '%';
      if(cmpLine) cmpLine.style.left = v + '%';
    };
    if(cmpRange){ cmpRange.addEventListener('input', function(){ setCmp(this.value); }); }
    setCmp(50);
  }
  // cart form
  var form = root.querySelector('[data-uvg-form]');
  if(form){
    var extraPairs = [].slice.call(root.querySelectorAll('.uvg-xpair'));
    function showExtraPairs(n){
      var box = root.querySelector('[data-uvg-xpairs]');
      var top = root.querySelector('[data-uvg-topsel]');
      var bundle = n>1;
      if(box) box.hidden = !bundle;
      if(top) top.hidden = bundle;
      extraPairs.forEach(function(p){ var idx=parseInt(p.getAttribute('data-xpair'),10)||1; p.hidden = (idx>n); });
    }
    extraPairs.forEach(function(p){
      p.querySelectorAll('.uvg-xsw').forEach(function(sw){
        sw.addEventListener('click', function(){
          p.querySelectorAll('.uvg-xsw').forEach(function(x){ x.classList.remove('active'); });
          sw.classList.add('active');
        });
      });
    });
    showExtraPairs(parseInt(state.tier,10)||1);

    form.addEventListener('submit', function(e){
      e.preventDefault();
      var _tier = parseInt(state.tier,10)||1;
      var fd = new FormData();
      if(_tier === 1){
        // single pair — real variant on the single product (SKU already correct)
        var vidInput = form.querySelector('[data-uvg-vid]');
        if(!vidInput || !vidInput.value || vidInput.value.indexOf('REPLACE_WITH') === 0){
          alert('שגיאה בהגדרת המוצר. פנה לתמיכה.');
          return;
        }
        fd.append('items[0][id]', vidInput.value);
        fd.append('items[0][quantity]', 1);
      } else {
        // bundle — each PAIR becomes its OWN line with its OWN real per-unit SKU
        // (pack-2 unit ₪124.50, pack-4 unit ₪107.25) so a MIXED pack ships each pair's
        // material+size correctly and the pack total stays ₪249 / ₪429.
        var arr = _tier===4 ? VD.bundle4 : VD.bundle2;
        var order = [], q = {};
        extraPairs.forEach(function(p){
          var idx = parseInt(p.getAttribute('data-xpair'),10)||1;
          if(idx <= _tier){
            var _xa=p.querySelector('.uvg-xsw.active');
            var _xs=p.querySelector('.uvg-xsize');
            var mat = _xa?_xa.getAttribute('data-material'):state.material;
            var sz = _xs?_xs.value:state.size;
            var vid = bundleVid(arr, mat, sz);
            if(vid){ if(q[vid]==null){ q[vid]=0; order.push(vid); } q[vid]++; }
          }
        });
        if(!order.length){ alert('שגיאה בהגדרת המוצר. פנה לתמיכה.'); return; }
        var _ix=0;
        for(var _o=0;_o<order.length;_o++){ fd.append('items['+_ix+'][id]', order[_o]); fd.append('items['+_ix+'][quantity]', q[order[_o]]); _ix++; }
      }
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if(cart && typeof cart.getSectionsToRender === 'function'){
        fd.append('sections', cart.getSectionsToRender().map(function(s){return s.id}).join(','));
        fd.append('sections_url', window.location.pathname);
      }
      var cta = form.querySelector('[data-uvg-cta]');
      var origTxt = cta ? cta.textContent : '';
      if(cta){ cta.setAttribute('disabled','disabled'); cta.textContent = 'מוסיף…'; }
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add', {
        method: 'POST',
        headers: {'X-Requested-With':'XMLHttpRequest','Accept':'application/javascript'},
        body: fd
      }).then(function(r){ return r.json(); }).then(function(res){
        if(cart && typeof cart.renderContents === 'function'){
          cart.renderContents(res);
          // theme quirk: stale is-empty on <cart-drawer> hides items after AJAX add from empty cart
          if(cart.classList.contains('is-empty') && cart.querySelector('.cart-item')){ cart.classList.remove('is-empty'); }
        } else {
          window.location.href = (window.Shopify.routes.root || '/') + 'cart';
        }
      }).catch(function(){
        window.location.href = (window.Shopify.routes.root || '/') + 'cart';
      }).finally(function(){
        if(cta){ cta.removeAttribute('disabled'); cta.textContent = origTxt; }
      });
    });
  }
})();


/* ---- floating buy box ---- */
(function(){
  var root = document.getElementById('uverix-gloves');
  if(!root) return;
  var form = root.querySelector('[data-uvg-form]');
  var bar  = root.querySelector('[data-uvg-floatbar]');
  if(!form) return;

  var PRICES = {'1':149,'2':249,'4':429};
  var WAS    = {'1':229,'2':458,'4':916};
  var MATCODE = {'במבוק אפור':'BGRY','פרפורמנס שחור':'PBLK'};

  function curState(){
    var sw = root.querySelector('.uvg-swatch.active');
    var sizeEl = root.querySelector('[data-uvg-size]');
    var tierEl = root.querySelector('.uvg-tier.active');
    return {
      material: sw ? sw.getAttribute('data-material') : 'במבוק אפור',
      size: sizeEl ? sizeEl.value : 'M',
      tier: tierEl ? tierEl.getAttribute('data-tier') : '1'
    };
  }
  function skuFor(s){
    if(s.tier === '2') return 'UVX-GLV-PACK2';
    if(s.tier === '4') return 'UVX-GLV-PACK4';
    return 'UVX-GLV-' + (MATCODE[s.material]||'BGRY') + '-' + s.size;
  }
  function setText(sel, txt){ var el = root.querySelector(sel); if(el) el.textContent = txt; }

  function sync(){
    var s = curState();
    var price = PRICES[s.tier], was = WAS[s.tier];
    var off = was ? Math.round((was - price) / was * 100) : 0;
    setText('[data-uvg-pricenow]', '₪' + price);
    setText('[data-uvg-pricewas]', '₪' + was);
    var offEl = root.querySelector('.uvg-price-off'); if(offEl) offEl.textContent = 'חיסכון ' + off + '%';
    setText('[data-uvg-floatprice]', '₪' + price);
    setText('[data-uvg-sku]', skuFor(s));
    setText('[data-uvg-matlabel]', '· ' + s.material);
  }

  // re-sync after the primary handlers run
  root.addEventListener('click', function(e){
    if(e.target.closest('.uvg-swatch') || e.target.closest('.uvg-tier')) setTimeout(sync, 0);
  });
  var sizeEl = root.querySelector('[data-uvg-size]');
  if(sizeEl) sizeEl.addEventListener('change', function(){ setTimeout(sync, 0); });
  sync();

  // floating bar: show once the buy form scrolls out of view
  if(bar && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting) bar.classList.remove('show');
        else if(en.boundingClientRect.top < 0) bar.classList.add('show');
        else bar.classList.remove('show');
      });
    }, {threshold: 0});
    io.observe(form);
  }
  var fcta = root.querySelector('[data-uvg-floatcta]');
  if(fcta){
    fcta.addEventListener('click', function(){
      var realCta = form.querySelector('[data-uvg-cta]');
      if(typeof form.requestSubmit === 'function'){ form.requestSubmit(realCta || undefined); }
      else if(realCta){ realCta.click(); }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uverix-knee"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.currentScript ? document.currentScript.closest('.uvx') : null;
    if(!root){ var all=document.querySelectorAll('.uvx'); root=all[all.length-1]; }
    if(!root) return;

    var uvxInited=false;
    var uvxData = { single: [], bundle2: null, bundle4: null };
    try { uvxData = JSON.parse((root.querySelector('#uvx-variant-data') || {}).textContent || '{}'); } catch(e){}

    var units = [].slice.call(root.querySelectorAll('.uvx-unit'));
    var unitsBox = root.querySelector('#uvx-units');
    var note = root.querySelector('#uvx-units-note');

    function singleId(color, size){
      var arr = uvxData.single || [];
      for(var i=0;i<arr.length;i++){ if(arr[i].color===color && arr[i].size===size) return arr[i].id; }
      return null;
    }
    function bundleId(arr, color, size){
      arr = arr || [];
      for(var i=0;i<arr.length;i++){ if(arr[i].color===color && arr[i].size===size) return arr[i].id; }
      return null;
    }
    function unitSel(u){
      var sw = u.querySelector('.uvx-usw.is-active');
      var sz = u.querySelector('.uvx-usize');
      return { color: sw ? sw.getAttribute('data-color') : null, size: sz ? sz.value : null };
    }
    function refreshSizes(u){
      var sw = u.querySelector('.uvx-usw.is-active');
      var color = sw ? sw.getAttribute('data-color') : null;
      var sel = u.querySelector('.uvx-usize');
      if(!sel || !color) return;
      var firstOk=null, selBad=false;
      [].forEach.call(sel.options, function(o){
        var ok = !!singleId(color, o.value);
        o.disabled = !ok;
        if(ok && firstOk===null) firstOk=o.value;
        if(o.selected && !ok) selBad=true;
      });
      if(selBad && firstOk!==null){ sel.value=firstOk; }
    }
    function currentTier(){
      var t = root.querySelector('.uvx-tier.is-selected');
      return t ? parseInt(t.getAttribute('data-qty')||'1',10) : 1;
    }
    function syncHidden(){   // keep hidden id synced to unit-1 single variant (native fallback)
      var s = unitSel(units[0]);
      var t0 = currentTier();
      var id = t0===2 ? bundleId(uvxData.bundle2, s.color, s.size) : (t0===4 ? bundleId(uvxData.bundle4, s.color, s.size) : singleId(s.color, s.size));
      var idEl = root.querySelector('#uvx-variant-id');
      if(id && idEl) idEl.value = id;
      // native-fallback safety: if the form ever submits WITHOUT the split JS (JS off, or the user
      // clicked before the script bound), post the unit-1 pack variant at the PACK quantity so it
      // charges the full pack price (2×₪99.50=₪199 / 4×₪74.75=₪299), never half.
      var qEl = root.querySelector('#uvx-qty');
      if(qEl) qEl.value = t0;
      // reflect unit-1 colour: swap the tier thumbnails + scroll the gallery to that colour
      var cimg = {"אפור בהיר":"https://cdn.shopify.com/s/files/1/0678/2307/5478/files/5298eb2d-0cd1-41a9-917a-bd02d137a337.png","שחור":"https://cdn.shopify.com/s/files/1/0678/2307/5478/files/hf_20260708_200508_8991b4f1-0c70-41e3-9d60-067d2b73c0f4.png?v=1783541264","בז":"https://cdn.shopify.com/s/files/1/0678/2307/5478/files/hf_20260708_200511_814fb995-7d4f-47dc-8bcf-8f7f41dbe853.png?v=1783541263"};
      var cidx = {"אפור בהיר":1,"שחור":2,"בז":3};
      var a1 = units[0] ? units[0].querySelector('.uvx-usw.is-active') : null;
      var col1 = a1 ? a1.getAttribute('data-color') : null;
      if(col1 && cimg[col1]){
        root.querySelectorAll('.uvx-ttimg').forEach(function(t){ t.src = cimg[col1]; });
      }
    }
    function showUnits(n){
      units.forEach(function(u,idx){ u.hidden = idx >= n; });
      if(unitsBox) unitsBox.classList.toggle('is-multi', n>1);
      if(note) note.textContent = n>1 ? ('בחרו צבע ומידה לכל אחת מ־'+n+' היחידות:') : 'בחרו צבע ומידה:';
    }

    // per-unit color swatches + size
    units.forEach(function(u){
      u.querySelectorAll('.uvx-usw').forEach(function(s){
        s.addEventListener('click', function(){
          u.querySelectorAll('.uvx-usw').forEach(function(x){ x.classList.remove('is-active'); });
          s.classList.add('is-active');
          refreshSizes(u);
          syncHidden();
        });
      });
      var sz = u.querySelector('.uvx-usize');
      if(sz) sz.addEventListener('change', syncHidden);
    });

    // bundle tiers
    var qty = root.querySelector('#uvx-qty');
    root.querySelectorAll('.uvx-tier').forEach(function(tier){
      tier.addEventListener('click', function(){
        root.querySelectorAll('.uvx-tier').forEach(function(x){ x.classList.remove('is-selected'); });
        tier.classList.add('is-selected');
        var radio = tier.querySelector('input'); if(radio) radio.checked = true;
        var n = parseInt(tier.getAttribute('data-qty')||'1',10);
        if(qty) qty.value = '1';
        showUnits(n);
        units.forEach(refreshSizes);
        syncHidden();
      });
    });
    showUnits(1);
    units.forEach(refreshSizes);
    syncHidden();
    uvxInited=true;

    // ADD-ON cross-sell (קרסול + כפפות): mark to add on ATC -> ride along as extra items[] lines
    var addonData = {};
    try { addonData = JSON.parse((root.querySelector('#uvx-addon-data')||{}).textContent||'{}'); } catch(e){}
    var addonEls = [].slice.call(root.querySelectorAll('.uvx-ao'));
    function aoCfg(ao){ return addonData[ao.getAttribute('data-ao')] || null; }
    function aoTier(ao){
      var d = aoCfg(ao); if(!d) return null;
      var b = ao.querySelector('.uvx-ao-tier.is-active');
      var n = b ? parseInt(b.getAttribute('data-n'),10) : d.tiers[0].n;
      for(var i=0;i<d.tiers.length;i++){ if(d.tiers[i].n===n){ return d.tiers[i]; } }
      return d.tiers[0];
    }
    function aoPaint(ao){
      var t = aoTier(ao); if(!t) return;
      var now = ao.querySelector('.uvx-ao-now');
      var was = ao.querySelector('.uvx-ao-was');
      var sv  = ao.querySelector('.uvx-ao-save');
      if(now){ now.textContent = '₪' + t.t; }
      if(was){ was.textContent = '₪' + t.w; }
      if(sv){  sv.textContent  = 'חוסכים ₪' + (t.w - t.t); }
    }
    addonEls.forEach(function(ao){
      var cb  = ao.querySelector('.uvx-ao-cb');
      var cfg = ao.querySelector('.uvx-ao-cfg');
      if(cb && cfg){
        cb.addEventListener('change', function(){ cfg.hidden = !cb.checked; ao.classList.toggle('is-on', cb.checked); });
      }
      ao.querySelectorAll('.uvx-ao-colors .uvx-usw').forEach(function(sw){
        sw.addEventListener('click', function(){
          ao.querySelectorAll('.uvx-ao-colors .uvx-usw').forEach(function(x){ x.classList.remove('is-active'); });
          sw.classList.add('is-active');
        });
      });
      ao.querySelectorAll('.uvx-ao-tier').forEach(function(tb){
        tb.addEventListener('click', function(){
          ao.querySelectorAll('.uvx-ao-tier').forEach(function(x){ x.classList.remove('is-active'); });
          tb.classList.add('is-active');
          aoPaint(ao);
        });
      });
      aoPaint(ao);
    });
    function selectedAddonItems(){
      var out = [];
      addonEls.forEach(function(ao){
        var cb = ao.querySelector('.uvx-ao-cb');
        if(!cb || !cb.checked) return;
        var d = aoCfg(ao); if(!d) return;
        var t = aoTier(ao); if(!t) return;
        var map = (d.maps || {})[t.map] || [];
        var id = null;
        if(!d.opts){ id = map.length ? map[0].id : null; }
        else {
          var sw  = ao.querySelector('.uvx-ao-colors .uvx-usw.is-active');
          var val = sw ? sw.getAttribute('data-val') : null;
          var szEl = ao.querySelector('.uvx-ao-size');
          var sz  = szEl ? szEl.value : null;
          for(var i=0;i<map.length;i++){ if(map[i].v===val && map[i].s===sz){ id = map[i].id; break; } }
        }
        if(id){ out.push({ id: id, q: t.q }); }
      });
      return out;
    }

    // scrollable gallery: thumbs scroll the carousel; scrolling syncs the active thumb
    var slidesEl = root.querySelector('#uvx-slides');
    var slideEls = [].slice.call(root.querySelectorAll('.uvx-slide'));
    var thumbEls = [].slice.call(root.querySelectorAll('.uvx-dot'));
    function goSlide(idx){ if(idx==null||!slideEls[idx]) return; slideEls[idx].scrollIntoView({inline:'center', block:'nearest', behavior:'smooth'}); }
    function setActiveThumb(idx){ thumbEls.forEach(function(x){ x.classList.toggle('is-active', parseInt(x.getAttribute('data-go')||'-1',10)===idx); }); }
    thumbEls.forEach(function(t){ t.addEventListener('click', function(){ goSlide(parseInt(t.getAttribute('data-go')||'0',10)); }); });
    if(slidesEl && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(ents){ ents.forEach(function(e){ if(e.isIntersecting && e.intersectionRatio>0.55){ setActiveThumb(slideEls.indexOf(e.target)); } }); }, {root:slidesEl, threshold:[0.55]});
      slideEls.forEach(function(s){ io.observe(s); });
    }

    // add to cart -> AJAX; each sleeve is its OWN line with its OWN real variant/SKU, open native drawer
    var form = root.querySelector('#uvx-form');
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var tier = currentTier();
        var n = tier;
        var specs = [];
        for(var ui=0; ui<n && ui<units.length; ui++){ specs.push(unitSel(units[ui])); }

        // Each physical sleeve becomes its OWN cart line with its OWN real variant/SKU
        // (single / pack-2 / pack-4 variant matching the chosen colour+size), so a MIXED
        // pack ships the correct colour+size per unit. Identical units merge into one line
        // with a quantity. Per-unit price: single ₪135, pack-2 ₪99.50, pack-4 ₪74.75
        // → 2×99.50=₪199, 4×74.75=₪299 (pack total unchanged).
        var vArr = tier===2 ? uvxData.bundle2 : (tier===4 ? uvxData.bundle4 : uvxData.single);
        var lineOrder = [];   // distinct variant ids, first-seen order
        var lineQty = {};
        for(var li=0; li<specs.length; li++){
          var vid = bundleId(vArr, specs[li].color, specs[li].size);
          if(!vid) continue;
          if(lineQty[vid]==null){ lineQty[vid]=0; lineOrder.push(vid); }
          lineQty[vid]++;
        }
        if(lineOrder.length===0){ form.submit(); return; }

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var fd = new FormData();
        var itemIx = 0;
        for(var lo=0; lo<lineOrder.length; lo++){
          fd.append('items['+itemIx+'][id]', lineOrder[lo]);
          fd.append('items['+itemIx+'][quantity]', lineQty[lineOrder[lo]]);
          itemIx++;
        }
        var addonIds = selectedAddonItems();
        for(var aI=0; aI<addonIds.length; aI++){
          fd.append('items['+itemIx+'][id]', addonIds[aI].id);
          fd.append('items['+itemIx+'][quantity]', addonIds[aI].q);
          itemIx++;
        }
        if(cart && typeof cart.getSectionsToRender === 'function'){
          fd.append('sections', cart.getSectionsToRender().map(function(s){ return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
        }
        var btn = form.querySelector('.uvx-cta-add');
        if(btn && !btn.dataset.label){ btn.dataset.label = btn.textContent; }
        if(btn){ btn.disabled = true; btn.textContent = 'מוסיף לעגלה…'; }

        fetch('/cart/add', { method:'POST', headers:{ 'Accept':'application/javascript', 'X-Requested-With':'XMLHttpRequest' }, body: fd })
        .then(function(r){ return r.json(); })
        .then(function(response){
          if(btn){ btn.disabled=false; btn.textContent = btn.dataset.label || 'הוספה לעגלה'; }
          if(response && response.status){ window.location.href = '/cart'; return; }
          if(cart && typeof cart.renderContents === 'function'){
            cart.classList.remove('is-empty');
            if(typeof cart.setActiveElement === 'function' && btn){ try{ cart.setActiveElement(btn); }catch(e){} }
            cart.renderContents(response);
          } else { window.location.href = '/cart'; }
        })
        .catch(function(){
          if(btn){ btn.disabled=false; btn.textContent = btn.dataset.label || 'הוספה לעגלה'; }
          window.location.href = '/cart';
        });
      });
    }

    // sticky add-to-cart bar: show after scrolling past the buy box top, hide while buy box on screen
    var sb = document.getElementById('uvx-stickybar');
    var buyEl = root.querySelector('#uvx-buy');
    if(sb && buyEl && 'IntersectionObserver' in window){
      var seen=false;
      new IntersectionObserver(function(en){ en.forEach(function(x){
        if(x.isIntersecting){ seen=true; sb.classList.add('is-hidden'); }
        else if(seen){ sb.classList.remove('is-hidden'); }
      }); },{threshold:0.12}).observe(buyEl);
    }

    // show-more reviews
    var moreBtn = document.getElementById('uvx-morebtn');
    var revSec = root.querySelector('.uvx-reviews');
    if(moreBtn && revSec){
      moreBtn.addEventListener('click', function(){
        revSec.classList.add('show-all');
        moreBtn.style.display='none';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uverix-meniscus"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.currentScript ? document.currentScript.closest('.uvx') : null;
    if(!root){ var all=document.querySelectorAll('.uvx'); root=all[all.length-1]; }
    if(!root) return;

    var uvxInited=false;
    var uvxData = { single: [], bundle2: null, bundle4: null };
    try { uvxData = JSON.parse((root.querySelector('#uvx-variant-data') || {}).textContent || '{}'); } catch(e){}

    var units = [].slice.call(root.querySelectorAll('.uvx-unit'));
    var unitsBox = root.querySelector('#uvx-units');
    var note = root.querySelector('#uvx-units-note');

    function singleId(color, size){
      var arr = uvxData.single || [];
      for(var i=0;i<arr.length;i++){ if(arr[i].color===color && arr[i].size===size) return arr[i].id; }
      return null;
    }
    function bundleId(arr, color, size){
      arr = arr || [];
      for(var i=0;i<arr.length;i++){ if(arr[i].color===color && arr[i].size===size) return arr[i].id; }
      return null;
    }
    function unitSel(u){
      var sw = u.querySelector('.uvx-usw.is-active');
      var sz = u.querySelector('.uvx-usize');
      return { color: sw ? sw.getAttribute('data-color') : null, size: sz ? sz.value : null };
    }
    function refreshSizes(u){
      var sw = u.querySelector('.uvx-usw.is-active');
      var color = sw ? sw.getAttribute('data-color') : null;
      var sel = u.querySelector('.uvx-usize');
      if(!sel || !color) return;
      var firstOk=null, selBad=false;
      [].forEach.call(sel.options, function(o){
        var ok = !!singleId(color, o.value);
        o.disabled = !ok;
        if(ok && firstOk===null) firstOk=o.value;
        if(o.selected && !ok) selBad=true;
      });
      if(selBad && firstOk!==null){ sel.value=firstOk; }
    }
    function currentTier(){
      var t = root.querySelector('.uvx-tier.is-selected');
      return t ? parseInt(t.getAttribute('data-qty')||'1',10) : 1;
    }
    function syncHidden(){   // keep hidden id synced to unit-1 single variant (native fallback)
      var s = unitSel(units[0]);
      var t0 = currentTier();
      var id = t0===2 ? bundleId(uvxData.bundle2, s.color, s.size) : (t0===4 ? bundleId(uvxData.bundle4, s.color, s.size) : singleId(s.color, s.size));
      var idEl = root.querySelector('#uvx-variant-id');
      if(id && idEl) idEl.value = id;
      // native-fallback safety: if the form ever submits WITHOUT the split JS (JS off, or the user
      // clicked before the script bound), post the unit-1 pack variant at the PACK quantity so it
      // charges the full pack price (2×₪99.50=₪199 / 4×₪74.75=₪299), never half.
      var qEl = root.querySelector('#uvx-qty');
      if(qEl) qEl.value = t0;
      // reflect unit-1 colour: swap the tier thumbnails + scroll the gallery to that colour
      var cimg = {"אפור בהיר":"https://cdn.shopify.com/s/files/1/0678/2307/5478/files/5298eb2d-0cd1-41a9-917a-bd02d137a337.png","שחור":"https://cdn.shopify.com/s/files/1/0678/2307/5478/files/hf_20260708_200508_8991b4f1-0c70-41e3-9d60-067d2b73c0f4.png?v=1783541264","בז":"https://cdn.shopify.com/s/files/1/0678/2307/5478/files/hf_20260708_200511_814fb995-7d4f-47dc-8bcf-8f7f41dbe853.png?v=1783541263"};
      var cidx = {"אפור בהיר":1,"שחור":2,"בז":3};
      var a1 = units[0] ? units[0].querySelector('.uvx-usw.is-active') : null;
      var col1 = a1 ? a1.getAttribute('data-color') : null;
      if(col1 && cimg[col1]){
        root.querySelectorAll('.uvx-ttimg').forEach(function(t){ t.src = cimg[col1]; });
      }
    }
    function showUnits(n){
      units.forEach(function(u,idx){ u.hidden = idx >= n; });
      if(unitsBox) unitsBox.classList.toggle('is-multi', n>1);
      if(note) note.textContent = n>1 ? ('בחרו צבע ומידה לכל אחת מ־'+n+' היחידות:') : 'בחרו צבע ומידה:';
    }

    // per-unit color swatches + size
    units.forEach(function(u){
      u.querySelectorAll('.uvx-usw').forEach(function(s){
        s.addEventListener('click', function(){
          u.querySelectorAll('.uvx-usw').forEach(function(x){ x.classList.remove('is-active'); });
          s.classList.add('is-active');
          refreshSizes(u);
          syncHidden();
        });
      });
      var sz = u.querySelector('.uvx-usize');
      if(sz) sz.addEventListener('change', syncHidden);
    });

    // bundle tiers
    var qty = root.querySelector('#uvx-qty');
    root.querySelectorAll('.uvx-tier').forEach(function(tier){
      tier.addEventListener('click', function(){
        root.querySelectorAll('.uvx-tier').forEach(function(x){ x.classList.remove('is-selected'); });
        tier.classList.add('is-selected');
        var radio = tier.querySelector('input'); if(radio) radio.checked = true;
        var n = parseInt(tier.getAttribute('data-qty')||'1',10);
        if(qty) qty.value = '1';
        showUnits(n);
        units.forEach(refreshSizes);
        syncHidden();
      });
    });
    showUnits(1);
    units.forEach(refreshSizes);
    syncHidden();
    uvxInited=true;

    // scrollable gallery: thumbs scroll the carousel; scrolling syncs the active thumb
    var slidesEl = root.querySelector('#uvx-slides');
    var slideEls = [].slice.call(root.querySelectorAll('.uvx-slide'));
    var thumbEls = [].slice.call(root.querySelectorAll('.uvx-dot'));
    function goSlide(idx){ if(idx==null||!slideEls[idx]) return; slideEls[idx].scrollIntoView({inline:'center', block:'nearest', behavior:'smooth'}); }
    function setActiveThumb(idx){ thumbEls.forEach(function(x){ x.classList.toggle('is-active', parseInt(x.getAttribute('data-go')||'-1',10)===idx); }); }
    thumbEls.forEach(function(t){ t.addEventListener('click', function(){ goSlide(parseInt(t.getAttribute('data-go')||'0',10)); }); });
    if(slidesEl && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(ents){ ents.forEach(function(e){ if(e.isIntersecting && e.intersectionRatio>0.55){ setActiveThumb(slideEls.indexOf(e.target)); } }); }, {root:slidesEl, threshold:[0.55]});
      slideEls.forEach(function(s){ io.observe(s); });
    }

    // add to cart -> AJAX, per-unit specs as line-item properties, open native drawer
    var form = root.querySelector('#uvx-form');
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var tier = currentTier();
        var n = tier;
        var specs = [];
        for(var ui=0; ui<n && ui<units.length; ui++){ specs.push(unitSel(units[ui])); }

        // Each physical sleeve = its OWN cart line with its OWN real variant/SKU so a MIXED
        // pack ships the correct colour+size per unit. Identical units merge with a quantity.
        // Per-unit price: single ₪135, pack-2 ₪99.50, pack-4 ₪74.75 → 2×99.50=₪199, 4×74.75=₪299.
        var vArr = tier===2 ? uvxData.bundle2 : (tier===4 ? uvxData.bundle4 : uvxData.single);
        var lineOrder = [];
        var lineQty = {};
        for(var li=0; li<specs.length; li++){
          var vid = bundleId(vArr, specs[li].color, specs[li].size);
          if(!vid) continue;
          if(lineQty[vid]==null){ lineQty[vid]=0; lineOrder.push(vid); }
          lineQty[vid]++;
        }
        if(lineOrder.length===0){ form.submit(); return; }

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var fd = new FormData();
        for(var lo=0; lo<lineOrder.length; lo++){
          fd.append('items['+lo+'][id]', lineOrder[lo]);
          fd.append('items['+lo+'][quantity]', lineQty[lineOrder[lo]]);
        }
        if(cart && typeof cart.getSectionsToRender === 'function'){
          fd.append('sections', cart.getSectionsToRender().map(function(s){ return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
        }
        var btn = form.querySelector('.uvx-cta-add');
        if(btn && !btn.dataset.label){ btn.dataset.label = btn.textContent; }
        if(btn){ btn.disabled = true; btn.textContent = 'מוסיף לעגלה…'; }

        fetch('/cart/add', { method:'POST', headers:{ 'Accept':'application/javascript', 'X-Requested-With':'XMLHttpRequest' }, body: fd })
        .then(function(r){ return r.json(); })
        .then(function(response){
          if(btn){ btn.disabled=false; btn.textContent = btn.dataset.label || 'הוספה לעגלה'; }
          if(response && response.status){ window.location.href = '/cart'; return; }
          if(cart && typeof cart.renderContents === 'function'){
            cart.classList.remove('is-empty');
            if(typeof cart.setActiveElement === 'function' && btn){ try{ cart.setActiveElement(btn); }catch(e){} }
            cart.renderContents(response);
          } else { window.location.href = '/cart'; }
        })
        .catch(function(){
          if(btn){ btn.disabled=false; btn.textContent = btn.dataset.label || 'הוספה לעגלה'; }
          window.location.href = '/cart';
        });
      });
    }

    // sticky add-to-cart bar: show after scrolling past the buy box top, hide while buy box on screen
    var sb = document.getElementById('uvx-stickybar');
    var buyEl = root.querySelector('#uvx-buy');
    if(sb && buyEl && 'IntersectionObserver' in window){
      new IntersectionObserver(function(en){ en.forEach(function(x){
        if(x.isIntersecting){ sb.classList.add('is-hidden'); }
        else { sb.classList.remove('is-hidden'); }
      }); },{threshold:0.1}).observe(buyEl);
      var sbCta = sb.querySelector('.uvx-sb-cta');
      if(sbCta){ sbCta.addEventListener('click', function(e){ e.preventDefault(); buyEl.scrollIntoView({behavior:'smooth', block:'start'}); }); }
    }

    // show-more reviews
    var moreBtn = document.getElementById('uvx-morebtn');
    var revSec = root.querySelector('.uvx-reviews');
    if(moreBtn && revSec){
      moreBtn.addEventListener('click', function(){
        revSec.classList.add('show-all');
        moreBtn.style.display='none';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uverix-nervelotion"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('.uvxn');
  var root = roots[roots.length-1];
  if(!root) return;

  // gallery: thumb click -> scroll slide; track scroll -> active thumb
  var track = root.querySelector('#uvxn-track');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.uvxn-thumb'));
  var slides = Array.prototype.slice.call(root.querySelectorAll('.uvxn-slide'));
  function setActiveThumb(i){ thumbs.forEach(function(t,j){ t.classList.toggle('is-active', j===i); }); }
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      var i = parseInt(t.getAttribute('data-i'),10) || 0;
      if(slides[i]) slides[i].scrollIntoView({behavior:'smooth', inline:'center', block:'nearest'});
      setActiveThumb(i);
    });
  });
  if(track){
    var st;
    track.addEventListener('scroll', function(){
      clearTimeout(st);
      st = setTimeout(function(){
        var i = Math.round(track.scrollLeft / track.clientWidth);
        i = Math.max(0, Math.min(slides.length-1, Math.abs(i)));
        setActiveThumb(i);
      }, 60);
    });
  }

  // variant tiers
  var vdata = [];
  try { vdata = JSON.parse((root.querySelector('#uvxn-variant-data')||{}).textContent || '[]'); } catch(e){}
  var idEl = root.querySelector('#uvxn-variant-id');
  var addBtn = root.querySelector('.uvxn-cta-add');
  var tiers = Array.prototype.slice.call(root.querySelectorAll('.uvxn-tier'));

  function fmt(n){ n = parseFloat(n); return (n % 1 === 0) ? n.toFixed(0) : n.toFixed(2); }
  function selectPack(pack){
    var match = null;
    for(var i=0;i<vdata.length;i++){ if(vdata[i].pack===pack){ match = vdata[i]; break; } }
    tiers.forEach(function(t){
      var on = t.getAttribute('data-pack')===pack;
      t.classList.toggle('is-active', on);
      var r = t.querySelector('input[type=radio]'); if(r) r.checked = on;
    });
    if(match){
      if(idEl) idEl.value = match.id;
      if(addBtn) addBtn.textContent = 'הוספה לעגלה — ₪' + fmt(match.price);
    }
  }
  tiers.forEach(function(t){
    t.addEventListener('click', function(){ selectPack(t.getAttribute('data-pack')); });
  });
  // init from checked
  var checked = root.querySelector('.uvxn-tier input[type=radio]:checked');
  if(checked){ selectPack(checked.value); }

  // scroll-to-top CTA
  var scrollBtn = root.querySelector('#uvxn-scrolltop');
  if(scrollBtn){ scrollBtn.addEventListener('click', function(){ root.scrollIntoView({behavior:'smooth', block:'start'}); }); }

  // add to cart -> native drawer (mirror product-form.js)
  var form = root.querySelector('#uvxn-form');
  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var id = idEl ? idEl.value : '';
      if(!id){ form.submit(); return; }
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', 1);
      if(cart && typeof cart.getSectionsToRender === 'function'){
        fd.append('sections', cart.getSectionsToRender().map(function(s){ return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      }
      if(addBtn && !addBtn.dataset.label){ addBtn.dataset.label = addBtn.textContent; }
      if(addBtn){ addBtn.disabled = true; addBtn.textContent = 'מוסיף לעגלה…'; }
      fetch('/cart/add', { method:'POST', headers:{ 'Accept':'application/javascript', 'X-Requested-With':'XMLHttpRequest' }, body: fd })
      .then(function(r){ return r.json(); })
      .then(function(response){
        if(addBtn){ addBtn.disabled=false; addBtn.textContent = addBtn.dataset.label || 'הוספה לעגלה'; }
        if(response && response.status){ window.location.href = '/cart'; return; }
        if(cart && typeof cart.renderContents === 'function'){
          cart.classList.remove('is-empty');
          if(typeof cart.setActiveElement === 'function' && addBtn){ try{ cart.setActiveElement(addBtn); }catch(e){} }
          cart.renderContents(response);
        } else { window.location.href = '/cart'; }
      })
      .catch(function(){
        if(addBtn){ addBtn.disabled=false; addBtn.textContent = addBtn.dataset.label || 'הוספה לעגלה'; }
        window.location.href = '/cart';
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uverix-topper"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.currentScript ? document.currentScript.closest('.uvxt') : null;
  if(!root){ var all=document.querySelectorAll('.uvxt'); root=all[all.length-1]; }
  if(!root) return;

  var vdata=[];
  try{ vdata=JSON.parse((root.querySelector('#uvxt-vdata')||{}).textContent||'[]'); }catch(e){}
  var sizeEl=root.querySelector('#uvxt-size');
  var idEl=root.querySelector('#uvxt-vid');
  var priceEl=root.querySelector('#uvxt-price');
  var cpriceEl=root.querySelector('#uvxt-cprice');
  var offEl=root.querySelector('#uvxt-off');

  function fmt(n){ return '₪'+Math.round(n).toLocaleString('he-IL'); }
  function updateVariant(){
    var size=sizeEl?sizeEl.value:null, m=null;
    for(var i=0;i<vdata.length;i++){ if(vdata[i].size===size){ m=vdata[i]; break; } }
    if(!m) return;
    if(idEl) idEl.value=m.id;
    if(priceEl) priceEl.textContent=fmt(m.price);
    if(cpriceEl){ if(m.cprice){ cpriceEl.style.display=''; cpriceEl.textContent=fmt(m.cprice); } else { cpriceEl.style.display='none'; } }
    if(offEl){ if(m.cprice&&m.cprice>m.price){ offEl.style.display=''; offEl.textContent=Math.round((1-m.price/m.cprice)*100)+'%- הנחה'; } else { offEl.style.display='none'; } }
  }
  if(sizeEl) sizeEl.addEventListener('change',updateVariant);
  updateVariant();

  // size guide toggle
  var gt=root.querySelector('#uvxt-guide-toggle'), gm=root.querySelector('#uvxt-guide-mini');
  if(gt&&gm) gt.addEventListener('click',function(){ gm.hidden=!gm.hidden; });

  // quantity stepper
  var qtyEl=root.querySelector('#uvxt-qty');
  root.querySelectorAll('.uvxt-qbtn').forEach(function(b){
    b.addEventListener('click',function(){
      var v=parseInt(qtyEl.value||'1',10)||1; v+=parseInt(b.getAttribute('data-d'),10); if(v<1)v=1; if(v>10)v=10; qtyEl.value=v;
    });
  });

  // gallery: thumb click scrolls slide; slide scroll updates active thumb
  var slides=root.querySelector('#uvxt-slides'), thumbs=root.querySelectorAll('.uvxt-thumb');
  thumbs.forEach(function(t){
    t.addEventListener('click',function(){
      var i=+t.getAttribute('data-i');
      var s=slides.children[i]; if(s) slides.scrollTo({left:s.offsetLeft*(document.dir==='rtl'?-1:1)||s.offsetLeft, behavior:'smooth'});
      if(s) s.scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'});
      thumbs.forEach(function(x){x.classList.remove('is-active');}); t.classList.add('is-active');
    });
  });
  if(slides){
    slides.addEventListener('scroll',function(){
      var i=Math.round(Math.abs(slides.scrollLeft)/slides.clientWidth);
      thumbs.forEach(function(x){x.classList.remove('is-active');});
      if(thumbs[i]) thumbs[i].classList.add('is-active');
    },{passive:true});
  }

  // video autoplay on view
  var vids=root.querySelectorAll('.uvxt-vid');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){ es.forEach(function(en){ var v=en.target; if(en.isIntersecting){ v.play&&v.play().catch(function(){}); } else { v.pause&&v.pause(); } }); },{threshold:.25});
    vids.forEach(function(v){ io.observe(v); });
  }

  // add to cart -> native drawer
  var form=root.querySelector('#uvxt-form');
  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault(); updateVariant();
      var id=idEl?idEl.value:''; if(!id){ form.submit(); return; }
      var q=parseInt((qtyEl&&qtyEl.value)||'1',10)||1;
      var cart=document.querySelector('cart-notification')||document.querySelector('cart-drawer');
      var fd=new FormData(); fd.append('id',id); fd.append('quantity',q);
      if(cart&&typeof cart.getSectionsToRender==='function'){ fd.append('sections',cart.getSectionsToRender().map(function(s){return s.id;}).join(',')); fd.append('sections_url',window.location.pathname); }
      var btn=form.querySelector('.uvxt-cta-add'); if(btn&&!btn.dataset.label) btn.dataset.label=btn.textContent; if(btn){ btn.disabled=true; btn.textContent='מוסיף לעגלה…'; }
      fetch('/cart/add',{method:'POST',headers:{'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){return r.json();})
      .then(function(res){
        if(btn){ btn.disabled=false; btn.textContent=btn.dataset.label||'הוספה לעגלה'; }
        if(res&&res.status){ window.location.href='/cart'; return; }
        if(cart&&typeof cart.renderContents==='function'){ cart.classList.remove('is-empty'); if(typeof cart.setActiveElement==='function'&&btn){ try{cart.setActiveElement(btn);}catch(e){} } cart.renderContents(res); }
        else { window.location.href='/cart'; }
      })
      .catch(function(){ if(btn){ btn.disabled=false; btn.textContent=btn.dataset.label||'הוספה לעגלה'; } window.location.href='/cart'; });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
